import { useEffect } from "react";
import Header from "./components/header";
import Main from "./components/main";
import Footer from "./components/footer";
import ChatMeSDK from "./components/ChatMeScript";
import ScrollToTopButton from "../../components/ScrollToTopButton";

const LandingPage = () => {
  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src = "https://sdk.chatme.vn/cm.js";
  //   script.setAttribute("data-chatme-id", "2b3537ee395b403d7875b21465c2043a");
  //   script.async = true;
  //   document.body.appendChild(script);

  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  return (
    <div className="flex flex-col w-full">
      <Header />
      <Main />
      <Footer />
      <ScrollToTopButton />
      <ChatMeSDK/>
    </div>
  );
};

export default LandingPage;
